/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import Service from 'services/Service';

class OpenAIService extends Service {
  constructor() {
    super();

    this.createChatCompletion = this.createChatCompletion.bind(this);
  }

  createChatCompletion(payload) {
    return this.post(`/openai/v1/chat/completions`, payload);
  }
}

export default new OpenAIService();
